"use strict";

exports.__esModule = true;
var _ReportKindSelector = require("./ReportKindSelector");
Object.keys(_ReportKindSelector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ReportKindSelector[key]) return;
  exports[key] = _ReportKindSelector[key];
});